/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  settings: 'Settings',
  setting: 'Setting',
  defaultLocale: 'Default Locale',
  mail: 'Mail',
  driver: 'Driver',
  host: 'Host',
  port: 'Port',
  username: 'Username',
  password: 'Password',
  encryption: 'Encryption',
  fromAddress: 'From Address',
  fromName: 'From Name',
  save: 'Save',
  saveSuccess: 'Settings saved successfully.',
  saveFailure: 'Settings could not be saved.',
  fetchFailure: 'Settings could not be fetched.',
  updates: 'Updates',
  update: 'Update',
  newUpdatesAvailable: 'There are new updates available for download.',
  beforeUpdatingMakeSure: 'Before updating make sure that the Plainpad installation directory is writable by the PHP process. In case the update ends with an error, you may have to manually run the "php artisan refresh" command from the terminal in order to finalize the process.',
}
